module.exports = __webpack_public_path__ + "img/security-key-no.34ba4a8e.svg";